import React, { useEffect, useState } from "react";
import api from "@api";
import { NavLink, useParams } from "react-router-dom";
import "./DirectoryLeagueGame.css";

function DirectoryLeagueGame() {
  const { leagueNameAndId, gameId } = useParams();
  const directoryLeagueId = leagueNameAndId?.split("-").pop();

  const [league, setLeague] = useState(null);
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGamePage = async () => {
      try {
        const [leagueRes, gameRes] = await Promise.all([
          api.get(`/api/directory/leagues/${directoryLeagueId}`),
          api.get(`/api/directory/leagues/${directoryLeagueId}/games/${gameId}`),
        ]);

        setLeague(leagueRes.data);
        setGame(gameRes.data);
      } catch (err) {
        console.error("Failed to fetch game page", err);
      } finally {
        setLoading(false);
      }
    };

    if (directoryLeagueId && gameId) {
      fetchGamePage();
    }
  }, [directoryLeagueId, gameId]);

  if (loading) {
    return <div className="directory-game-page">Loading game...</div>;
  }

  if (!game) {
    return <div className="directory-game-page">Game not found.</div>;
  }

  const homeTeamName = game.homeTeam?.team?.name || "Team TBD";
  const awayTeamName = game.awayTeam?.team?.name || "Team TBD";

  const homeTeamId = game.homeTeam?.id;
  const awayTeamId = game.awayTeam?.id;

  const homeScore = Number(game.score_home || 0);
  const awayScore = Number(game.score_away || 0);

  const hasScore = homeScore > 0 || awayScore > 0;

  const gameDate = game.date ? new Date(`${game.date}T23:59:59`) : null;
  const isPast = gameDate && gameDate < new Date();

  const statusLabel = hasScore
    ? "Final"
    : isPast
      ? "Result pending"
      : "Upcoming";

  const formattedDate = game.date
    ? new Date(`${game.date}T00:00:00`).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    : "Date TBD";

  const formattedTime = game.time
    ? new Date(`1970-01-01T${game.time}`).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    })
    : "Time TBD";

  return (
    <div className="league-profile-page">
      <div className="league-profile-container">
        <div className="league-profile-public-tabs">
          <NavLink end to={`/leagues/${leagueNameAndId}`}>
            Overview
          </NavLink>

          <NavLink to={`/leagues/${leagueNameAndId}/schedule`}>
            Schedule
          </NavLink>

          <NavLink to={`/leagues/${leagueNameAndId}/standings`}>
            Standings
          </NavLink>

          <NavLink to={`/leagues/${leagueNameAndId}/players`}>
            Players
          </NavLink>
        </div>

        <div className="directory-game-page">
          <section className="directory-game-card">
        <div className="directory-game-top">
          <span
            className={`directory-game-status ${statusLabel
              .toLowerCase()
              .replace(" ", "-")}`}
          >
            {statusLabel}
          </span>
        </div>

        <div className="directory-game-scoreboard">
          <NavLink
            className="directory-game-team"
            to={`/leagues/${leagueNameAndId}/teams/${homeTeamId}`}
          >
            <span className="directory-game-team-label">Home</span>
            <h2>{homeTeamName}</h2>
            {hasScore && <strong>{homeScore}</strong>}
          </NavLink>

          <div className="directory-game-center">
            <span>vs</span>
          </div>

          <NavLink
            className="directory-game-team"
            to={`/leagues/${leagueNameAndId}/teams/${awayTeamId}`}
          >
            <span className="directory-game-team-label">Away</span>
            <h2>{awayTeamName}</h2>
            {hasScore && <strong>{awayScore}</strong>}
          </NavLink>
        </div>

        <div className="directory-game-details">
              <div className="directory-game-detail-box">
                <span>Date</span>
                <strong>{formattedDate}</strong>
              </div>

              <div className="directory-game-detail-box">
                <span>Time</span>
                <strong>{formattedTime}</strong>
              </div>

              {game.location_url ? (
                <a
                  href={game.location_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="directory-game-detail-box directory-game-location-box"
                >
                  <span>Location</span>
                  <strong>{game.location || "View location"}</strong>
                </a>
              ) : (
                  <div className="directory-game-detail-box">
                    <span>Location</span>
                    <strong>{game.location || "Location TBD"}</strong>
                  </div>
              )}
        </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default DirectoryLeagueGame;